class CurrencySwitcher extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    /* ?country= in URL check - Start */
    // eslint-disable-next-line compat/compat
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    })
    this.countryParam = params.country

    if (this.countryParam !== null) {
      const countryCode = this.countryParam
      window.localStorage.setItem(this.userLocationName, countryCode)
    } else if (this.noLocationStored) {
      window.BAO.Utils.fetchJSON('/browsing_context_suggestions.json', {
        method: 'GET',
      }).then(res => {
        const countryCode = res.detected_values.country.handle
        const countryCodeStorage = window.localStorage.getItem(
          this.userLocationName,
        )

        if (countryCode !== countryCodeStorage) {
          window.localStorage.setItem(this.userLocationName, countryCode)

          if (countryCode === this.dataset.isoCode) return
          this.setActive(countryCode)
        }
      })
    }
  }

  async setActive (code) {
    const urlParams = new URLSearchParams(window.location.search)
    urlParams.set('country', code)

    await window.BAO.sectionRenderer
      .fetchSingle(
        'currency-switcher',
        `${window.location.pathname}?${urlParams.toString()}`,
      )
      .then(res => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.cur-Modal_Form')

        this.els.content.element.innerHTML = myself.innerHTML

        this.setAttribute('aria-hidden', false)
        document.body.classList.toggle('util-SiteOverflowed', true)
      })
      .then(() => {
        window.BAO.dispatchEvent(window.BAO.EVENTS.CLOSE_ALL_DRAWERS)
      })
      .catch(() => {
        this.setAttribute('aria-hidden', true)
        document.body.classList.toggle('util-SiteOverflowed', false)
      })
  }

  setupListeners () {
    super.setupListeners()

    this.handleClose = this.handleClose.bind(this)

    this.els.close.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleClose)
    })

    this.handleOpen = this.handleOpen.bind(this)

    this.externalEls.trigger.elements.forEach(close => {
      this.listeners.add(close, 'click', this.handleOpen)
    })

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.listeners.add(this, 'keydown', this.handleKeyDown)

    this.onExternalMenuLoad = this.onExternalMenuLoad.bind(this)
    this.listeners.add(document, 'menuLoaded', this.onExternalMenuLoad)
  }

  handleClose () {
    this.setAttribute('aria-hidden', 'true')
    document.body.classList.toggle('util-SiteOverflowed', false)

    if (this.activeTrigger) {
      this.activeTrigger.focus()
      this.activeTrigger = null
    }
  }

  handleOpen (event) {
    this.activeTrigger = event?.currentTarget ?? document.activeElement

    this.setAttribute('aria-hidden', 'false')
    document.body.classList.add('util-SiteOverflowed')

    setTimeout(() => {
      const closeButton = this.querySelector(
        'button[data-currency-switcher-el="close"]',
      )
      if (closeButton) closeButton.focus()
    }, 500)
  }

  handleKeyDown (event) {
    if (this.getAttribute('aria-hidden') === 'true') return

    if (event.key === 'Escape') {
      const openDropdown = this.querySelector(
        '[data-localization-option-el="button"][aria-expanded="true"]',
      )
      if (!openDropdown) this.handleClose()
      return
    }

    if (event.key === 'Tab') {
      this.trapFocus(event)
    }
  }

  trapFocus (event) {
    const focusableEls = this.getFocusableElements()
    if (!focusableEls.length) return

    const firstFocusableEl = focusableEls[0]
    const lastFocusableEl = focusableEls[focusableEls.length - 1]

    if (event.shiftKey && document.activeElement === firstFocusableEl) {
      event.preventDefault()
      lastFocusableEl.focus()
    } else if (!event.shiftKey && document.activeElement === lastFocusableEl) {
      event.preventDefault()
      firstFocusableEl.focus()
    }
  }

  getFocusableElements () {
    return Array.from(
      this.querySelectorAll(
        'a[href]:not([disabled]), button:not([disabled]), textarea:not([disabled]), input[type="text"]:not([disabled]), input[type="radio"]:not([disabled]), input[type="checkbox"]:not([disabled]), select:not([disabled])',
      ),
    ).filter(el => !el.closest('[hidden]') && el.getClientRects().length > 0)
  }

  onExternalMenuLoad () {
    document
      .querySelectorAll('[data-currency-switcher-external-el="trigger"]')
      .forEach(triggerEl => {
        if (
          triggerEl.querySelector(
            '[data-currency-switcher-external-el="label"]',
          )
        ) {
          triggerEl.querySelector(
            '[data-currency-switcher-external-el="label"]',
          ).innerHTML = `${this.dataset.currency} / ${this.dataset.name} - ${this.dataset.symbol}`
        }

        this.listeners.add(triggerEl, 'click', this.handleOpen)
      })
  }

  get userLocationName () {
    return 'BAO-localization'
  }

  get noLocationStored () {
    return (
      window.localStorage.getItem(this.userLocationName) == null ||
      (window.localStorage.getItem(this.userLocationName) === undefined &&
        !window.Shopify.designMode)
    )
  }
}

if (!customElements.get('currency-switcher')) {
  customElements.define('currency-switcher', CurrencySwitcher)
}
